import SupportForm from "features/SupportForm";
import React from "react";
import GoBack from "shared/ui/GoBack";
import s from "./style.module.scss";

const Support: React.FC = () => {
  return (
    <main className={s.support}>
      <GoBack black />

      <section>
        <h1>Обратная связь</h1>

        <SupportForm />
      </section>
    </main>
  );
};

export default Support;
